export default __webpack_public_path__ + "95591a929f0d32aa282a90ba5acf81f0.woff2";